import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import foto_gruppo from "../../assets/foto/gruppo-istruttori.jpg";

function Istruttori() {
  const { t } = useTranslation();

  return (
    <section id="istruttori" className="base-section">
      <div className="order-2 md:order-2">
        <img className="base-image" src={foto_gruppo} alt="istruttori" />
      </div>
      <div className="base-text-container order-1 md:order-1">
        <h2 className="base-title">{t("istruttori.title")}</h2>
        {t("istruttori.shortDescription", { returnObjects: true }).map(
          (text, index) => (
            <p key={index} className="mb-4">
              {text}
            </p>
          ),
        )}
        <Link to="/istruttori" className="base-link">
          {t("istruttori.more")}
          <i className="fas fa-angle-right ml-1 text-xl text-current"></i>
        </Link>
      </div>
    </section>
  );
}

export default Istruttori;
